export default function SaveButton({
  handleSubmit,
  showSpinner,
  style,
  text = "Update",
}) {
  return (
    <button
      onClick={handleSubmit}
      disabled={showSpinner}
      class="btn btn-primary mw105 my-1"
      style={style}
      href="#"
    >
      {showSpinner ? (
        <div class="spinner-border" role="status">
          <span class="sr-only"></span>
        </div>
      ) : (
        text
      )}
    </button>
  );
}
